import { Card } from "primereact/card";
import { JVDate } from "../../shared/JVDate";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";
import React, { useEffect, useRef, useState } from "react";
import { IBranchMastDropdown, ICompanyMastDropdown, IUsersDropdown } from "../../models/IDropdown";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";
import { SubTable } from "./SubTable";
import { Toast } from "primereact/toast";
import { ILogin, IPermissionProps } from "../../models/Login";
import { Dropdown } from "primereact/dropdown";

interface IPrimeVendorPerformanceReports {
    fromDate?: Date | null,
    toDate?: Date | null,
    prime_Vendor?: string | null,
    company_ID?: number | null,
    branch_ID?: number | null,
    salesManager_ID?: number | null,
    vendor_Company_ID?: number | null,
    isFilter?: number | null,
    frequency?: number | null,
}

interface IPrimeVendorPerformanceReportsTableData {
    vendor_Company_Name: string,
    req: number,
    sub: number,
    subEnd: number,
    eci: number,
    po: number,
}

const EmptyPrimeVendorPerformanceReports: IPrimeVendorPerformanceReports = {
    fromDate: new Date(),
    toDate: new Date(),
    prime_Vendor: "",
    company_ID: null,
    branch_ID: null,
    salesManager_ID: null,
    vendor_Company_ID: null
}

const schema = yup.object({
    fromDate: yup.date().nullable(),
    toDate: yup.date().nullable(),
    prime_Vendor: yup.string().nullable(),
    company_ID: yup.number().nullable(),
    branch_ID: yup.number().nullable(),
    salesManager_ID: yup.number().nullable(),
    vendor_Company_ID: yup.number().nullable(),
    frequency: yup.number().nullable(),
});

export const PrimeVendorPerformanceReports = (permissions: IPermissionProps) => {
    const [loading, setloading] = useState(false);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IPrimeVendorPerformanceReportsTableData>, loading: boolean });
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [salesManager, setSalesManager] = useState<Array<IUsersDropdown>>();
    const [shwTable, setShwTable] = useState(false);
    const [loadIcon, setLoadIcon] = useState(false);
    const [filter, setFilter] = useState<IPrimeVendorPerformanceReports>();
    const [shwSubTable, setShwSubTable] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [tFooter, setTFooter] = useState<any>({});
    const [excel, setExcel] = useState<boolean>(false);
    const [excelNum, setExcelNum] = useState<number | null>(0);
    const [excelLoading, setExcelLoading] = useState<boolean>(false);
     const [selectedSm, setselectedSm] = useState<any | null>(null);
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IPrimeVendorPerformanceReports>({
        resolver: yupResolver(schema),
        defaultValues: EmptyPrimeVendorPerformanceReports,
        shouldFocusError: false
    });

    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }
    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/reqBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }
    const loadSales = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        } else if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        }

        const response = await Fetch("Dropdown/SalesManagerList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSalesManager(data);
        }
    }

    // const loadReq = async (body: any) =>{
    //     body.vendor_Company_ID = 243;
    //     const response = await Fetch("PrimeVendorPerformanceReports/reqList","GET",null,`filter=${JSON.stringify(body)}&type="Req"`,null);
    //     if(response){
    //         const data: Array<any> = await response.json();
    //         console.log(data);
    //     }
    // };

    useEffect(() => {
        loadSales(0, 0, 0);
        loadCompanies();
        loadBranches();
    }, []);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company_ID") {
                if (value.company_ID != 0) {
                    loadBranches(value.company_ID);
                    loadSales(0, value.company_ID, 0);
                } else {
                    loadBranches();
                    if (value.branch_ID != 0) {
                        loadSales(value.branch_ID, 0, 0);
                    } else {
                        loadSales(0, 0, 0);
                    }
                }
            }

            if (name === "branch_ID") {
                if (value.branch_ID != 0) {
                    loadSales(value.branch_ID, 0, 0);
                } else {
                    if (value.company_ID != 0) {
                        loadSales(0, value.company_ID, 0);
                    } else {
                        loadSales(0, 0, 0);
                    }
                }
            }

            if (name === "frequency") {
                if (value.frequency != 0 && value.frequency != null) {
                    setExcelNum(prev => prev = value?.frequency || 0);
                    setExcel(prev => prev = true);
                } else {
                    setExcel(prev => prev = false);
                    setExcelNum(prev => prev = null);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    const loadTableDate = async (body: IPrimeVendorPerformanceReports) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        setLoadIcon(true);
        setFilter(body);
        const response = await Fetch("PrimeVendorPerformanceReports", "GET", null, `filter=${JSON.stringify(body)}`, null);
        if (response) {
            const data: Array<IPrimeVendorPerformanceReportsTableData> = await response.json();
            let totalNoOfReq = 0;
            let totalNoOfSub = 0;
            let totalNoOfSubClient = 0;
            let totalNoOfECI = 0;
            let totalNoOfPO = 0;

            data.forEach((d, i) => {
                if (d.req) totalNoOfReq += d.req;
                if (d.sub) totalNoOfSub += d.sub;
                if (d.subEnd) totalNoOfSubClient += d.subEnd;
                if (d.eci) totalNoOfECI += d.eci;
                if (d.po) totalNoOfPO += d.po;
            });
            const totalRecords: any = {
                total: "Total Records",
                noOfReq: totalNoOfReq,
                noOfSub: totalNoOfSub,
                noOfSubClient: totalNoOfSubClient,
                noOfECI: totalNoOfECI,
                noOfPO: totalNoOfPO
            };
            setTFooter(totalRecords);
            setTableData({ tableData: data, loading: false });
            setLoadIcon(false);
        }
    };

    const onSubmit = (data: IPrimeVendorPerformanceReports) => {
        let newDate = new Date;
        if (data.fromDate?.toDateString() !== newDate.toDateString() || (data.prime_Vendor !== null && data.prime_Vendor !== "") || (data.company_ID !== null && data.company_ID !== 0) || (data.branch_ID !== null && data.branch_ID !== 0) || (data.salesManager_ID !== null && data.salesManager_ID !== 0) || (data.vendor_Company_ID !== null && data.vendor_Company_ID !== 0)) {
            data.isFilter = 1;
        } else {
            data.isFilter = null;
        }

        delete data.frequency;

        loadTableDate(data);
    };

    const onSubmitForExcel = (data: IPrimeVendorPerformanceReports) => {
        let newDate = new Date;
        if (data.fromDate?.toDateString() !== newDate.toDateString() || (data.prime_Vendor !== null && data.prime_Vendor !== "") || (data.company_ID !== null && data.company_ID !== 0) || (data.branch_ID !== null && data.branch_ID !== 0) || (data.salesManager_ID !== null && data.salesManager_ID !== 0) || (data.vendor_Company_ID !== null && data.vendor_Company_ID !== 0)) {
            data.isFilter = 1;
        } else {
            data.isFilter = null;
        }
        downloadExcel(data, excelNum || 0);
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center flex justify-content-between bg-white">
            <h5 className="m-0">Prime Vendor Performance Reports</h5>
            {permissions.is_Export && <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />}
        </div>
    );

    const onClear = () => {
        reset(EmptyPrimeVendorPerformanceReports);
        setExcel(false);
        setExcelNum(0);
        setselectedSm(null);
    }

    const hideDialog = () => {
        setShwSubTable({ singleData: {}, open: false });
    }

    const subTable = (type?: string, rowData?: any) => {
        let data = {
            type: type,
            singleData: rowData,
            filter: filter
        };

        setShwSubTable({ singleData: data, open: true });
    }

    const openReqTable = (rowData: any) => {
        return <p className="text-primary cursor-pointer underline" onClick={() => subTable("Req", rowData)}>{rowData.req}</p>
    }

    const openSubTable = (rowData: any) => {
        return <p className="text-primary cursor-pointer underline" onClick={() => subTable("Sub", rowData)}>{rowData.sub}</p>
    }
    const openSubEndTable = (rowData: any) => {
        return <p className="text-primary cursor-pointer underline" onClick={() => subTable("SubClient", rowData)}>{rowData.subEnd}</p>
    }
    const openECITable = (rowData: any) => {
        return <p className="text-primary cursor-pointer underline" onClick={() => subTable("ECI", rowData)}>{rowData.eci}</p>
    }
    const openPOTable = (rowData: any) => {
        return <p className="text-primary cursor-pointer underline" onClick={() => subTable("PO", rowData)}>{rowData.po}</p>
    }

    const downloadExcel = async (data: IPrimeVendorPerformanceReports, exceltype: number) => {
        setExcelLoading(p => p = true);
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"PrimeVendorPerformanceReports/getexcel"}?` + `filter=${JSON.stringify(data)}` + `&exceltype=${exceltype}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `PrimeVendorPerformanceReports.xlsx`;
                a.href = href;
                a.click();
                a.href = '';
                setExcelLoading(p => p = false);
            } else if (response.status === 400) {
                const message = await response.text();
                toast.current.show({ severity: 'error', detail: message, life: 3000 });
                setExcelLoading(p => p = false);
            }
        } catch {
            setExcelLoading(p => p = false);
            toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    useEffect(() => {
        loadTableDate(EmptyPrimeVendorPerformanceReports);
    }, []);

    return (
        <>
            {permissions.is_View && <Card>
                <form onSubmit={handleSubmit(excel === true ? onSubmitForExcel : onSubmit)} className="p-fluid formgrid grid">
                    <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
                    <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
                    <JVInput column={6} label="Prime Vendor:" control={control} name="prime_Vendor" placeholder="Enter Prime Vendor" error={errors.prime_Vendor?.message} />
                    <JVDropdown column={6} label="Company" control={control} name="company_ID" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
                    <JVDropdown column={6} label="Branch" control={control} name="branch_ID" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />
                    <div className="field col-2 md:col-2">
                        <p>Sales Manager</p>
                        <Dropdown value={selectedSm} style={{ height: "37px", marginTop: "-10px" }} onChange={(e) => { setselectedSm(e.value); }} options={salesManager} optionLabel="user_Name" placeholder="Select Sales Manager" optionValue="login_ID" filter />
                    </div>
                    {/* <JVDropdown column={6} label="Sales Manager" control={control} name="salesManager_ID" options={salesManager} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" /> */}
                    {(_roles.includes(1) || _roles.includes(20) || _roles.includes(26) || _roles.includes(40)) && <JVDropdown column={6} label="Frequency" control={control} name="frequency" options={[{ label: "--SELECT--", value: 0 }, { label: "Daily", value: 4 }, { label: "Weekly", value: 1 }, { label: "Monthly", value: 2 }, { label: "Quarterly", value: 3 }]} optionLabel="label" optionValue="value" placeholder="Select Type Of Excel" />}
                    <div className="col-12 md:col-12">
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px' }}>
                            {!excel && <Button className="field col-12 md:col-6" label="FIND" type="submit" loading={loadIcon}></Button>}
                            {excel && <Button className="field col-12 md:col-6" loading={excelLoading} disabled={excelLoading} style={{ backgroundColor: "#9c27b0" }} label="GET EXCEL" type="submit" ></Button>}
                            <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={onClear} type="button"></Button>
                        </div>
                    </div>
                </form>
            </Card>}
            {permissions.is_View && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand"
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: '4rem' }} footer={""} />
                <Column field="vendor_Company_Name" header="Prime Vendor" sortable footer={tFooter.total} />
                <Column field="req" header="Req" sortable body={openReqTable} footer={tFooter.noOfReq} />
                <Column field="sub" header="Sub" body={openSubTable} footer={tFooter.noOfSub} />
                <Column field="subEnd" header="Sub End Client" body={openSubEndTable} footer={tFooter.noOfSubClient} />
                <Column field="eci" header="ECI" body={openECITable} footer={tFooter.noOfECI} />
                <Column field="po" header="PO" body={openPOTable} footer={tFooter.noOfPO} />
            </DataTable>}
            {permissions.is_View && <SubTable open={shwSubTable.open} singleData={shwSubTable.singleData} hideDialog={hideDialog} toast={toast} />}
            <Toast ref={toast} />
        </>
    );
}